import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  initGoogleContactInfo,
  toggleGoogleInviteModal,
  toggleGoogleInviteSuccess,
} from 'actions/google';

import inviteSuccessSrc from 'img/invite-success.png';

import Button from 'components/ui-components/button';

import './styles.less';

const SuccessPane = class extends Component {
  render() {
    const { inviteCount } = this.props;

    return (
      <div className="google-share-modal-backdrop" onClick={this.onClose}>
        <div
          className="google-share-modal-success"
          onClick={e => e.stopPropagation()}
        >
          <div className="close" onClick={() => this.onClose()} />
          <div className="success-sec">{`${inviteCount} invites have been sent via Gmail`}</div>
          <div className="success-primary">View Lists Unlocked!</div>
          <img src={inviteSuccessSrc} className="success-img" />
          <div className="success-text">
            You will now be able to see who viewed your videos! Hover over the
            video view count to access the video view list.
          </div>
          <Button
            buttonType="a1"
            buttonClass="goto-button"
            value="Go to Latest Video"
            onClicked={this.handleLatest}
          />
        </div>
      </div>
    );
  }

  handleLatest = () => {
    this.onClose('/most-recent-video');
  };

  onClose = optRedir => {
    if (optRedir) {
      window.location.href = optRedir;
    } else {
      window.location.reload();
    }
  };
};

const mapStateToProps = state => {
  const {
    google: { selections, contact_info },
  } = state;

  return {
    inviteCount: selections.length || 0,
    contactInfo: contact_info,
    selections,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleGoogleInviteSuccess: tOrF =>
      dispatch(toggleGoogleInviteSuccess(tOrF)),
    initGoogleContactInfo: info => dispatch(initGoogleContactInfo(info)),
    toggleGoogleInviteModal: tOrF => dispatch(toggleGoogleInviteModal(tOrF)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPane);
